module.exports = "fragment VerifyPhoneNumberFailureFragment on VerifyPhoneNumberFailure {\n  __typename\n  failureType\n  failureMessage\n}\n"